import Services from '../components/Services';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FloatingContactWidget from '../components/FloatingContactWidget';
import { useTheme } from '../contexts/ThemeContext';

const ServicesPage = () => {
    const { isDark } = useTheme();
    return (
        <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-white'} transition-colors duration-300`}>
            <Navbar />
            <div className="pt-20">
                <Services />
            </div>
            <Footer />
            <FloatingContactWidget />
        </div>
    );
};

export default ServicesPage;
